import { useIntl } from 'react-intl'

import MessageBanner from 'LuxKit/Banners/MessageBanner'

interface Props {
  origin?: string
  destination?: string
}

function OutOfSystemRangeFeederFlightsBanner({ origin, destination }: Props) {
  const intl = useIntl()

  if (!origin || !destination) return null

  const heading = intl.formatMessage(
    {
      id: 'cZN3HO8Z5Qd7-qjpY0JM',
      defaultMessage: 'Important: Connecting flights to {destination} not included',
      description: 'Warning heading when a Maldives charter feeder flight is outside the airline booking release window',
    },
    { destination },
  )

  const message = intl.formatMessage(
    {
      id: 'I03Sx5tkmuTO1FWwGhRh',
      defaultMessage: 'Flights from {origin} to {destination} aren’t available yet, as airlines typically release schedules around 11 months before departure. Your Maldives charter flight is confirmed. Your package price excludes this connection. We’ll contact you when flights are available to help arrange it.',
      description: 'Warning explaining that a Maldives charter feeder flight will become available closer to departure',
    },
    { origin, destination },
  )

  return <MessageBanner kind="warning" density="comfortable" heading={heading}>{message}</MessageBanner>
}

export default OutOfSystemRangeFeederFlightsBanner
